import BSFetch from '@beisen/fetch';
import qs from 'qs'

function createDynamicFunction() {
    const baseFunction = function (...args) {
        if (args[1]) {
            args[1] = { data: typeof args[1] === 'string' ? JSON.parse(args[1]) : (args[1].params ? args[1].params : args[1]) }
        }
        if (args[2]) {
            const query = args[2].params || {};
            const queryString = qs.stringify(query, { arrayFormat: 'brackets' });
            if (queryString) {
                const hasQuery = args[0].includes('?');
                args[0] += (hasQuery ? '&' : '?') + queryString;
            }
        }
        return BSFetch[baseFunction._key](...args).then(res => {
            return { data: res, status: 200 }
        }
        )
    };

    return new Proxy(baseFunction, {
        get(target, prop) {
            if (typeof prop === "symbol") return target[prop];
            target._key = prop;
            return (...args) => {
                return target(...args);
            };
        }
    });
}

const axios = createDynamicFunction();

export default axios
